// extracted by mini-css-extract-plugin
export default {"link":"common-link-module__link","link--arrow":"common-link-module__link--arrow","button":"common-link-module__button"};